import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Injector,
  Input,
  Output
} from '@angular/core';
import { Subscribable } from '../../../../../models/base/subscribable';
import { TypeService } from '../../../../../services/type/type-service';
import { map, startWith } from 'rxjs/operators';
import { PhoneDropdownItem } from '../../../../../models/shared/phone-dropdown-item';
import { EmployerAdditionalContactFormGroup } from '../../../../employers/add-employer/forms/employer-additional-contact-form-group';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployerRecordContactRemoveModalComponent } from '../employer-record-contact-remove-modal/employer-record-contact-remove-modal.component';
import { ModalUtils } from '../../../../../utils/modal-utils';

@Component({
  selector: 'app-employer-record-additional-contact-accordion',
  templateUrl: './employer-record-additional-contact-accordion.component.html',
  styleUrls: ['../employer-record-accordion.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerRecordAdditionalContactAccordionComponent extends Subscribable implements AfterViewInit {
  @Input() formGroup!: EmployerAdditionalContactFormGroup;
  @Input() isExpanded = false;
  @Input() formSubmitted = false;
  @Input() index: number = 0;
  @Output() toggle = new EventEmitter<void>();
  @Output() removeContact = new EventEmitter<void>();

  private typeService = inject(TypeService);
  private ngbModal = inject(NgbModal);
  private injector = inject(Injector);

  public countryCodeDropdowns$ = this.typeService.countries$.pipe(
    map(countries => countries?.map(c => new PhoneDropdownItem(c)))
  );

  public maskitoOptions = {
    contactTopic: {
      mask: /^.{0,40}$/
    }
  };

  public customErrorMessages = {
    firstName: {
      required: $localize`First Name required`
    },
    lastName: {
      required: $localize`Last Name required`
    },
    jobTitle: {
      required: $localize`Job Title required`
    },
    phoneNumber: {
      required: $localize`Phone Number required`
    },
    email: {
      required: $localize`Email required`
    },
    contactTopic: {
      required: $localize`Contact Topic required`,
      maxlength: $localize`Contact Topic must be no more than 40 characters`
    }
  };

  public remove(): void {
    const modalRef = this.ngbModal.open(
      EmployerRecordContactRemoveModalComponent,
      ModalUtils.defaultModalOptions(this.injector)
    );
    modalRef.componentInstance.setEmployerContactName(
      this.formGroup.value.firstName + ' ' + this.formGroup.value.lastName
    );
    modalRef.result.then(result => {
      if (result) this.removeContact.emit();
    });
  }

  private initializeFormListeners(): void {
    this.formGroup.controls.hasSigningAuthority.valueChanges
      .pipe(startWith(this.formGroup.controls.hasSigningAuthority.value))
      .subscribeWhileAlive({
        owner: this,
        next: hasSigningAuthority => {
          if (hasSigningAuthority) {
            this.formGroup.controls.address.enable({ emitEvent: false });
          } else {
            this.formGroup.controls.address.disable({ emitEvent: false });
          }
        }
      });
  }

  public ngAfterViewInit(): void {
    this.initializeFormListeners();
  }
}
